{
    "breadcrumbs": {
        "eligibility": "About you",
        "eligibility_mobile": "About you",
        "consent": "Consent",
        "consent_mobile": "Consent",
        "memory": "Test your brain age",
        "memory_mobile": "Test",
        "contact": "Contact details",
        "contact_mobile": "Contacts",
        "estimatedTime_one": "{{count, number}} min",
        "estimatedTime_other": "{{count, number}} mins",
        "done": "Done",
        "survey": "Do a quick survey",
        "survey_mobile": "Survey",
        "finish": "Finish",
        "finish_mobile": "Finish"
    },
    "footer": {
        "promotion": "Novoic Storyteller is being used to screen people from the comfort of their home at +50 institutions. Storyteller is not a medical device and does not have medical efficacy. It is not intended to diagnose or treat any disease. For any health concerns, please consult a medical professional.",
        "about": {
            "text": "About",
            "link": "https:\/\/novoic.com\/"
        },
        "terms": {
            "text": "Terms",
            "link": "https:\/\/novoic.com\/storyteller\/tos"
        },
        "privacy": {
            "text": "Privacy",
            "link": "https:\/\/novoic.com\/storyteller\/privacy"
        },
        "help": {
            "text": "Help Center",
            "link": "https:\/\/novoic.com\/"
        }
    },
    "stepper": {
        "title_mobile": "Step {{count, number}} of {{total, number}}: {{title}}"
    },
    "share": {
        "title": "Invite someone you care about to do Storyteller!",
        "divider": "or",
        "cta": "Send Invite",
        "buttons": {
            "copy": "Copy Link",
            "email": "Invite via Email"
        },
        "email": {
            "subject": "",
            "body": "{{link}}"
        }
    }
}
